




































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { LibraryCategoryArticle } from '~/domains/library/Library.types'

import BBAvatar from '~/components/BB/BBAvatar.vue'
import Card from '~/components/UI/Card.vue'

@Component({
  components: {
    Card,
    BBAvatar
  }
})
export default class LibraryArticleList extends Vue {
  @Prop({
    type: Array,
    default: () => ([]),
    required: true
  })
  articles: LibraryCategoryArticle[]
}
